import { render, staticRenderFns } from "./AdminRequirmentForm.vue?vue&type=template&id=bfd2cc6c"
import script from "./AdminRequirmentForm.vue?vue&type=script&lang=js"
export * from "./AdminRequirmentForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports